import React from 'react';
import Questionnaire from '../component/questionnaire';
import { processTransltionData, fetchTranslations } from '../hooks/withAppI18n';
import { transClientLanToLocal } from '@/util/common';

const DEFAULT_LAN = 'en';

export default () => {
  return <Questionnaire />;
};

export async function getServerSideProps(context) {
  const accessToken = context.req.headers['web-access-token'] || '';
  const lan = transClientLanToLocal(context.query?.lan) || DEFAULT_LAN;

  return {
    props: {
      omiEnv: process.env.OMI_ENV || '',
      nodeEnv: process.env.NODE_ENV || '',
      accessToken,
      lan,
      isDev: process.env.TEST_ENV === 'test',
    },
  };
}
